export default __webpack_public_path__ + "assets/images/bbd07daae515c4db0de65a187808f4c8.png";